import React from "react";
import Modal from '../../components/Modal/Modal.jsx';
import { MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBView } from 'mdbreact';



class SectionCarousel extends React.Component {

  state = {
    isOpen: false,
    imgs: this.props.imgs,
    length: this.props.imgs.length
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      imgs: newProps.imgs,
      length: newProps.imgs.length
    });
  }

  render() {
    return (
      <Modal open={false}>
        <MDBCarousel activeItem={1} length={this.state.length} showControls={true} showIndicators={true} className="z-depth-2" slide>
          <MDBCarouselInner>


            {this.state.imgs.map((prop, key) =>
              <MDBCarouselItem itemId={key + 1} key={key}>
                <MDBView>
                  <img className="d-block w-100"
                    src={prop}
                    alt=""
                    onClick={() =>
                      this.setState({ isOpen: true })}
                  />

                </MDBView>
              </MDBCarouselItem>

            )
            }

          </MDBCarouselInner>
        </MDBCarousel>

      </Modal>
    );
  }
}

export default SectionCarousel;



// WEBPACK FOOTER //
// ./src/components/CardCarusel/CardCarusel.jsx